import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { PermissionsProvider } from './contexts/PermissionsContext.tsx';
import Layout from './components/Layout/Layout.tsx';
import Login from './pages/Login.tsx';
import Dashboard from './pages/Dashboard.tsx';
import Products from './pages/Products.tsx';
import BulkProducts from './pages/BulkProducts.tsx';
import Inventory from './pages/Inventory.tsx';
import InventoryAlerts from './pages/InventoryAlerts.tsx';
import ProductionOrders from './pages/ProductionOrders.tsx';
import ProductionSchedule from './pages/ProductionSchedule.tsx';
import ProductionDashboard from './pages/ProductionDashboard.tsx';
import Reports from './pages/Reports.tsx';
import ViewReports from './pages/ViewReports.tsx';
import AutoAlerts from './pages/AutoAlerts.tsx';
import DailyReports from './pages/DailyReports.tsx';
import IssuesTracker from './pages/IssuesTracker.tsx';
import SalesReportsPage from './pages/SalesReportsPage.tsx';
import ExecutiveDashboardPage from './pages/reports/ExecutiveDashboardPage.tsx';
import ExecutiveDashboardSegmentedPage from './pages/reports/ExecutiveDashboardSegmentedPage.tsx';
import SqlExplorationPage from './pages/reports/SqlExplorationPage.tsx';
import Admin from './pages/Admin.tsx';
import AdminRedirect from './components/AdminRedirect.tsx';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <PermissionsProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/bulk-products" element={<BulkProducts />} />
                        <Route path="/inventory" element={<Inventory />} />
                        <Route path="/inventory-alerts" element={<InventoryAlerts />} />
                        <Route path="/production-orders" element={<ProductionOrders />} />
                        <Route path="/production-schedule" element={<ProductionSchedule />} />
                        <Route path="/production-dashboard" element={<ProductionDashboard />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/reports/view" element={<ViewReports />} />
                        <Route path="/reports/auto-alerts" element={<AutoAlerts />} />
                        <Route path="/reports/daily" element={<DailyReports />} />
                        <Route path="/reports/issues" element={<IssuesTracker />} />
                        <Route path="/reports/sales" element={<SalesReportsPage />} />
                        <Route
                          path="/reports/executive-dashboard/:type/:id"
                          element={<ExecutiveDashboardSegmentedPage />}
                        />
                        <Route
                          path="/reports/executive-dashboard"
                          element={<ExecutiveDashboardPage />}
                        />
                        <Route path="/reports/exploration" element={<SqlExplorationPage />} />
                        <Route path="/admin" element={<AdminRedirect />} />
                        <Route path="/admin/users" element={<Admin />} />
                        <Route path="/admin/roles" element={<Admin />} />
                        <Route path="/admin/audit" element={<Admin />} />
                        <Route path="/admin/schedule" element={<Admin />} />
                        <Route path="/admin/production-lines" element={<Admin />} />
                        <Route path="/admin/invoice-processing" element={<Admin />} />
                        <Route path="/admin/performance" element={<Admin />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </Router>
      </PermissionsProvider>
    </AuthProvider>
  );
}

export default App;
